import React from 'react';
import FormSection from '../../../FormElements/FormSection';
import Label from '../../../FormElements/Label';
import TextInput from '../../../FormElements/TextInput';
import PrimaryButton from '../../../Buttons/PrimaryButton';
import SecondaryButton from '../../../Buttons/SecondaryButton';

export default class OwnershipFormSection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			businessOwner1TaxIdType: 'from prop ownership',
			businessOwner1TaxId: 'from prop ownership',
			businessOwner1FirstName: 'from prop ownership',
			businessOwner1LastName: 'from prop ownership',
			businessOwner1ResidentialAddress1: 'from acct profile',
			businessOwner1ResidentialAddress2: 'from acct profile',
			businessOwner1ResidentialAddressCity: 'from acct profile',
			businessOwner1ResidentialAddressState: 'from acct profile',
			businessOwner1ResidentialAddressPostalCode: 'from acct profile',
			businessOwner1Email: 'from acct profile',
			businessOwner1PhoneNumber: 'from acct profile',
			businessOwner2TaxType: 'from prop ownership',
			businessOwner2TaxId: 'from prop ownership',
			businessOwner2FirstName: 'from prop ownership',
			businessOwner2LastName: 'from prop ownership',
			businessOwner2MiddleInitial: 'from prop ownership',
			businessOwner2ResidentialAddress1: 'from acct profile',
			businessOwner2ResidentialAddress2: 'from acct profile',
			businessOwner2ResidentialAddressCity: 'from acct profile',
			businessOwner2ResidentialAddressState: 'from acct profile',
			businessOwner2ResidentialAddressPostalCode: 'from acct profile',
			businessOwner2Email: 'from acct profile',
			businessOwner2PhoneNumber: 'from acct profile'
		};

		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log('OwnershipFormSection', this.props);
		return (
			<div className="w-full py-4">
				<FormSection>
					<Label htmlFor="businessOwner1TaxIdType">
						Business Owner 1 Tax Type *
					</Label>
					<TextInput
						id="businessOwner1TaxIdType"
						name="businessOwner1TaxIdType"
						value={this.state.businessOwner1TaxIdType}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1TaxId">Businuess Owner 1 Tax ID</Label>
					<TextInput
						id="businessOwner1TaxId"
						name="businessOwner1TaxId"
						value={this.state.businessOwner1TaxId}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1FirstName">
						Business Owner 1 First Name
					</Label>
					<TextInput
						id="businessOwner1FirstName"
						name="businessOwner1FirstName"
						value={this.state.businessOwner1FirstName}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1LastName">
						Business Owner 1 Last Name
					</Label>
					<TextInput
						id="businessOwner1LastName"
						name="businessOwner1LastName"
						value={this.state.businessOwner1LastName}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1PhoneNumber">
						Business Owner 1 Phone Number
					</Label>
					<TextInput
						id="businessOwner1PhoneNumber"
						name="businessOwner1PhoneNumber"
						value={this.state.businessOwner1PhoneNumber}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1Email">
						Business Owner 1 Email Address
					</Label>
					<TextInput
						id="businessOwner1Email"
						name="businessOwner1Email"
						value={this.state.businessOwner1Email}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1ResidentialAddress1">
						Address Line 1 *
					</Label>
					<TextInput
						id="businessOwner1ResidentialAddress1"
						name="businessOwner1ResidentialAddress1"
						value={this.state.businessOwner1ResidentialAddress1}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1ResidentialAddress2">
						Address Line 2
					</Label>
					<TextInput
						id="businessOwner1ResidentialAddress2"
						name="businessOwner1ResidentialAddress2"
						value={this.state.businessOwner1ResidentialAddress2}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1ResidentialAddressCity">City *</Label>
					<TextInput
						id="businessOwner1ResidentialAddressCity"
						name="businessOwner1ResidentialAddressCity"
						value={this.state.businessOwner1ResidentialAddressCity}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1ResidentialAddressState">State *</Label>
					<TextInput
						id="businessOwner1ResidentialAddressState"
						name="businessOwner1ResidentialAddressState"
						value={this.state.businessOwner1ResidentialAddressState}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner1ResidentialAddressPostalCode">
						Zip Code *
					</Label>
					<TextInput
						id="businessOwner2ResidentialAddressPostalCode"
						name="businessOwner2ResidentialAddressPostalCode"
						value={this.state.businessOwner2ResidentialAddressPostalCode}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2TaxType">
						Business Owner 2 Tax Type *
					</Label>
					<TextInput
						id="businessOwner2TaxType"
						name="businessOwner2TaxType"
						value={this.state.businessOwner2TaxType}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2TaxId">Businuess Owner 2 Tax ID</Label>
					<TextInput
						id="businessOwner2TaxId"
						name="businessOwner2TaxId"
						value={this.state.businessOwner2TaxId}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2FirstName">
						Business Owner 2 First Name
					</Label>
					<TextInput
						id="businessOwner2FirstName"
						name="businessOwner2FirstName"
						value={this.state.businessOwner2FirstName}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2LastName">
						Business Owner 2 Last Name
					</Label>
					<TextInput
						id="businessOwner2LastName"
						name="businessOwner2LastName"
						value={this.state.businessOwner2LastName}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2PhoneNumber">
						Business Owner 2 Phone Number
					</Label>
					<TextInput
						id="businessOwner2PhoneNumber"
						name="businessOwner2PhoneNumber"
						value={this.state.businessOwner2PhoneNumber}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2Email">
						Business Owner 2 Email Address
					</Label>
					<TextInput
						id="businessOwner2Email"
						name="businessOwner2Email"
						value={this.state.businessOwner2Email}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2ResidentialAddress1">
						Address Line 1 *
					</Label>
					<TextInput
						id="businessOwner2ResidentialAddress1"
						name="businessOwner2ResidentialAddress1"
						value={this.state.businessOwner2ResidentialAddress1}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2ResidentialAddress2">
						Address Line 2
					</Label>
					<TextInput
						id="businessOwner2ResidentialAddress2"
						name="businessOwner2ResidentialAddress2"
						value={this.state.businessOwner2ResidentialAddress2}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2ResidentialAddressCity">City *</Label>
					<TextInput
						id="businessOwner2ResidentialAddressCity"
						name="businessOwner2ResidentialAddressCity"
						value={this.state.businessOwner2ResidentialAddressCity}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2ResidentialAddressState">State *</Label>
					<TextInput
						id="businessOwner2ResidentialAddressState"
						name="businessOwner2ResidentialAddressState"
						value={this.state.businessOwner2ResidentialAddressState}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessOwner2ResidentialAddressPostalCode">
						Zip Code *
					</Label>
					<TextInput
						id="businessOwner2ResidentialAddressPostalCode"
						name="businessOwner2ResidentialAddressPostalCode"
						value={this.state.businessOwner2ResidentialAddressPostalCode}
						onChange={this.onChange}
					/>
				</FormSection>

				<div className="grid">
					<div className="lg:justify-self-end mb-4 lg:mb-0">
						<SecondaryButton
							label="Continue"
							onClick={() => {
								this.props.continueLocation(
									this.state.businessOwner1TaxIdType,
									this.state.businessOwner1TaxId,
									this.state.businessOwner1FirstName,
									this.state.businessOwner1LastName,
									this.state.businessOwner1ResidentialAddress1,
									this.state.businessOwner1ResidentialAddress2,
									this.state.businessOwner1ResidentialAddressCity,
									this.state.businessOwner1ResidentialAddressState,
									this.state.businessOwner1ResidentialAddressPostalCode,
									this.state.businessOwner1Email,
									this.state.businessOwner1PhoneNumber,
									this.state.businessOwner2TaxType,
									this.state.businessOwner2TaxId,
									this.state.businessOwner2FirstName,
									this.state.businessOwner2LastName,
									this.state.businessOwner2MiddleInitial,
									this.state.businessOwner2ResidentialAddress1,
									this.state.businessOwner2ResidentialAddress2,
									this.state.businessOwner2ResidentialAddressCity,
									this.state.businessOwner2ResidentialAddressState,
									this.state.businessOwner2ResidentialAddressPostalCode,
									this.state.businessOwner2Email,
									this.state.businessOwner2PhoneNumber
								);
							}}
						/>
					</div>
				</div>
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}
}
